import type { FC } from 'react';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import type { NodeProps } from '../../types';

import { IconFont } from '@/components/IconFont';
import { isEmpty } from 'radash';
import { SealNodeType } from './types';

const Node: FC<NodeProps<SealNodeType>> = ({ id, data }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const showExpandBtn = useMemo(
    () => data.tags && data.tags?.length > 7,
    [data.tags],
  );
  const displayedTags = useMemo(
    () => (isExpanded ? data.tags : data.tags?.slice(0, 7)),
    [isExpanded, data.tags],
  );

  const toggleExpand = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setIsExpanded((prev) => !prev);
  }, []);

  if (isEmpty(displayedTags?.filter(Boolean))) return null;

  return (
    <>
      <div
        className={`overflow-hidden mt-2 space-y-2 transition-all duration-300  overflow-y-hidden relative`}
      >
        <div className="space-y-2">
          {displayedTags?.map((tag, idx) => (
            <div key={idx} className="bg-[#F4F7FF] px-2 py-1 rounded-md">
              <div className="text-sm">
                {tag?.table_name && `${tag?.table_name} - `}
                {tag?.tag_name}
              </div>
            </div>
          ))}
        </div>
        {!isExpanded && showExpandBtn && (
          <div className="right-0 bottom-0 left-0 absolute bg-gradient-to-t from-white to-transparent h-8" />
        )}
      </div>
      {showExpandBtn && (
        <div
          onClick={toggleExpand}
          className="-bottom-1 relative flex justify-center items-center text-[#8B8F97] cursor-pointer"
        >
          <span className="text-sm">{isExpanded ? '收起' : '展开'}</span>
          <IconFont
            type="icon-xiangxia"
            className={`ml-1 transition-transform duration-300 ${
              isExpanded ? 'rotate-180' : ''
            }`}
          />
        </div>
      )}
    </>
  );
};

export default React.memo(Node);
